import { JSONStringify, isEmptyValue } from '@/utils/common'
import {
  collaboratorsRef,
  createTimeAndActionRef,
  orderAndDocumentCountRef,
  orderDetailRef,
  orderHeroRef,
  orderSectionsRef,
  removeCollaboratorRef,
  updateTaskAssigneeRef,
  updateTimeAndActionRef,
  orderSectionSummary,
  getSupplierRef,
  getOrderSettingRef,
  getAddOrderSettingRef,
  createPropertyOrderPropertyRef,
  createPropertyValueRef,
  getAllOrderPropertyRef,
  createTimeActionTemplateRef,
  getTimeActionTemplateRef,
  updateTimeActionTemplateRef,
  getFactoryRef,
  getOrderTemplateRef,
  updateOrderTemplateRef,
  updateCollaboratorRef,
  searchUserByEmailRef,
  downloadPomExcelRef,
  uploadPomExcelRef,
  downloadOrderTemplateExcelRef,
  uploadOrderExcelRef,
  getOrderItemSettingRef,
  orderSummary,
  getOrderColumnRef,
  getOrderSequentialByEntityService,
} from './Order.service'
import { tranformCollaboratorForSubmit } from './OrderOverview/components/TimeAndAction/TimeAction.helper'
import FormDataLib from 'form-data'
import { saveOrderExcel } from '@/utils/filesaver'
import { ITimeAndActionPayload } from '../interface/order.interface'
import { includes, pick, map } from 'lodash'
import {
  COLUMN_WIDTH,
  DROP_COLUMNS_END,
  DROP_COLUMNS_START,
} from './Order.constant'
import {
  IOrderSequentialProperty,
  IOrderSetting,
} from '@/interface/order.interface'

export async function getOrderOverView(orderId: string) {
  const tmpOrderHero = await orderHeroRef(orderId)
  const tmpOrderSections = await orderSectionsRef(orderId)
  return {
    orderHero: tmpOrderHero.data.data,
    OrderSections: tmpOrderSections.data.data,
  }
}

export async function createTimeAndAction(
  payload: ITimeAndActionPayload,
  userId: string
) {
  const tmpPayload = payload
  tmpPayload.time_actions.sections = payload.time_actions.sections.map(
    (item) => {
      return {
        ...item,
        tasks: item?.tasks.map((task) => {
          return {
            ...task,
            created_by: {
              id: userId,
            },
          }
        }),
      }
    }
  )
  tmpPayload.collaborations = tranformCollaboratorForSubmit(
    payload.collaborations
  )
  return await createTimeAndActionRef(tmpPayload)
}

export async function updateTimeAndAction(
  payload: ITimeAndActionPayload,
  userId: string,
  timeActionId: string
) {
  const tmpPayload = payload
  tmpPayload.time_actions.sections = payload.time_actions.sections.map(
    (item) => {
      return {
        ...item,
        tasks: item?.tasks.map((task) => {
          return {
            ...task,
            created_by: {
              id: userId,
            },
          }
        }),
      }
    }
  )
  tmpPayload.collaborations = tranformCollaboratorForSubmit(
    payload.collaborations
  )
  return await updateTimeAndActionRef(tmpPayload, timeActionId)
}

export async function updateCollaborator(orderId: string, payload: any) {
  const newPayload = payload
    .filter((item) => isEmptyValue(item.assignmentId))
    .map((item) => {
      return {
        roles: { role: item.role, permissions: [] },
        user_id: item.id,
      }
    })
  for (const item of newPayload) {
    await updateCollaboratorRef(orderId, item)
  }
}

export async function searchUserByEmail(email: string) {
  const { data } = await searchUserByEmailRef(email)
  return data?.data
}

export async function getOrderDetail(id: string) {
  const order = (await orderDetailRef(id)).data.data
  const collaborator = (await collaboratorsRef(id)).data.data
  return {
    order,
    collaborator,
  }
}

export async function getCollaboratorsForTasks(id: string) {
  const collaborator = (await collaboratorsRef(id)).data.data
  return collaborator.map((item) => {
    return {
      roles: item.roles,
      user: item.user,
    }
  })
}

export async function updateTaskAssignee(taskId: string, data: any) {
  const payload = {
    collaborations: [
      {
        user_id: data,
      },
    ],
  }
  return await updateTaskAssigneeRef(taskId, payload)
}

export async function getOrderAndDocumentCountByTask(taskId: string) {
  return (await orderAndDocumentCountRef(taskId)).data.data
}

export async function removeCollaborator(orderId: string, data: any) {
  const payload = {
    collboarations: [
      {
        userId: data.id,
      },
    ],
  }
  return await removeCollaboratorRef(orderId, payload)
}

// TODO: REMOVE
export async function getOrderSummary(queryParams = {}) {
  const data = await orderSummary(queryParams)
  return data
}

export async function getOrderSectionSummaryByOrderId(id: string) {
  const sections = await orderSectionSummary(id)
  return sections.data.data
}

export async function getSupplier(company_id: string) {
  return (await getSupplierRef(company_id))?.data?.data
}

export async function getFactory() {
  return (await getFactoryRef())?.data?.data?.map((item) => {
    return {
      name: item.name,
      id: item.id,
    }
  })
}

export async function getSequentialOrderPropertiesByEntity(params: {
  actionField: any
  companyId: string
}): Promise<Array<IOrderSequentialProperty>> {
  try {
    const { actionField, companyId = '' } = params
    const { entity_type = '' } = actionField

    const queryParams = {
      entity_type,
      company_id: companyId,
    }
    const { data = [] } = await getOrderSequentialByEntityService(queryParams)

    return data
  } catch (error) {
    console.log('error : ', error)
    return []
  }
}

export async function getOrderSetting(
  company_id: string
): Promise<IOrderSetting> {
  try {
    const response = await getOrderSettingRef(company_id)
    const values = response?.data?.data[0].value

    return values
  } catch (error) {
    return {}
  }
}

export async function getAddOrderSetting(user) {
  const { company, subscriptions } = user
  const pickRole = pick(subscriptions[0]?.role_access, ['role'])
  const addOrderSetting = await getAddOrderSettingRef(company?.company_id)

  if (!addOrderSetting) return true

  const { roles } = addOrderSetting
  const isAllowAddOrder = includes(roles, pickRole.role)
  return isAllowAddOrder
}

export async function getOrderItemSetting(company_id: string) {
  return (await getOrderItemSettingRef(company_id))?.data?.data?.[0]?.value
}

export type ORDER_CUSTOM_COLUMNS_TYPE = {
  key: string
  type: 'default' | 'addon'
  field?: string
  name?: string
  display_order: number
  data_source: any
  sortable?: any
  fromApi?: false
  value?: string
}

export async function getOrderColumnTransform() {
  try {
    const { data = [] } = await getOrderColumnRef()

    const pickField = ['value']
    const { value } = pick(data[0], pickField)

    //TO BE REMOVE
    const fixedWidth = {
      shipmentDate: COLUMN_WIDTH,
      retailPrice: COLUMN_WIDTH,
      costPrice: COLUMN_WIDTH,
      fabricCode: COLUMN_WIDTH,
      freightMode: COLUMN_WIDTH,
      freightCost: COLUMN_WIDTH,
      story: COLUMN_WIDTH,
      label: COLUMN_WIDTH,
      margin: COLUMN_WIDTH,
      orderQuantity: COLUMN_WIDTH,
    }

    const mapValues = map(
      value?.columns,
      (item: ORDER_CUSTOM_COLUMNS_TYPE) => ({
        key: item.field,
        value: item.name,
        displayOrder: item.display_order,
        type: item.type,
        dataSource: item.data_source,
        sortable: item.sortable || {},
        // width: fixedWidth[item.field],
        fromApi: true, // Flag represent fetching from api
      })
    )
    const concatValue = [
      ...DROP_COLUMNS_START,
      ...DROP_COLUMNS_END,
      ...mapValues,
    ]

    return concatValue
  } catch (error) {
    console.log(error)
  }
}

export const orderPagination = (
  data: any,
  onPageNumberChange: (page_number) => any
) => {
  return {
    defaultCurrent: data?.page_number ?? 1,
    total: data?.total_record ?? 1,
    showSizeChanger: false,
    pageSize: data?.page_size,
    onChange: (page) => onPageNumberChange(page),
  }
}

export const verifyPropertyExist = async (field: any, user: any) => {
  const data = await getAllOrderPropertyRef()
  const exist = data.data.data.some((item) => item.name == field.field)
  if (!exist) {
    const payload = {
      title: field.name,
      name: field.field,
      company_id: user.company.id,
      created_by: {
        id: user.id,
      },
      last_modified_by: {
        id: user.id,
      },
    }
    await createPropertyOrderPropertyRef(payload)
  }
}

export const onAddNewPropertyValue = async (item: any, value: any, user) => {
  const data = await getAllOrderPropertyRef()
  const tmp = data.data.data.find((value) => value.name == item.field)
  let selectedField = tmp
  if (isEmptyValue(tmp)) {
    const payload = {
      title: item?.title ?? item?.name,
      name: item?.field,
      company_id: user.company.id,
      created_by: {
        id: user.id,
      },
      last_modified_by: {
        id: user.id,
      },
    }
    selectedField = (await createPropertyOrderPropertyRef(payload))?.data.data
  }
  const payload = {
    table: 'properties',
    field: item?.field,
    data_type: 'string',
    values: [value],
  }
  return await createPropertyValueRef(selectedField?.id, payload).catch(
    (e) => e.response
  )
}

export async function createTimeActionTemplate(data: any) {
  return await createTimeActionTemplateRef(data)
}

export async function updateTimeActionTemplate(id, data: any) {
  return await updateTimeActionTemplateRef(id, data)
}

export async function getTimeActionTemplate() {
  return (await getTimeActionTemplateRef())?.data.data.map((item) => {
    return {
      id: item.id,
      label: item.name,
      value: JSONStringify(item.template_value),
    }
  })
}

export async function getTimeActionTemplateRaw() {
  return (await getTimeActionTemplateRef())?.data.data.map((item) => {
    return {
      label: item.name,
      value: JSONStringify(item),
    }
  })
}

export async function getOrderTemplate(data?: any) {
  return (await getOrderTemplateRef(data))?.data.data
}

export async function createOrderTemplate(data: any) {
  return await createTimeActionTemplateRef(data)
}

export async function updateOrderTemplate(id, data: any) {
  return await updateOrderTemplateRef(id, data)
}

export async function downloadPomExcel(body) {
  return await downloadPomExcelRef(body)
}

export async function downloadOrderTemplateExcel(body) {
  const data = await downloadOrderTemplateExcelRef(body)
  saveOrderExcel(new Blob([data.data]), body?.name)
  return ''
}

export async function uploadPomExcel(file, sizes) {
  const formData: any = new FormDataLib()
  formData.append('file', file), formData.append('sizes', JSON.stringify(sizes))
  return await uploadPomExcelRef(formData)
}

export async function uploadOrderExcel(file, template_id) {
  const formData: any = new FormDataLib()
  formData.append('file', file), formData.append('template_id', template_id)
  return await uploadOrderExcelRef(formData)
}
